<template>
    <div  class="dropdown-container position-relative col">
        <div class="dropdown-input dropdown border-default bg-primary-white  w-100 outline-none caption d-flex align-items-center" 
            @click="() => toggleShowHideDatePicker(true)">
            <DatePicker :show="showDatePicker" @close="() => toggleShowHideDatePicker(false)"/>
        </div>
		<div class="label" style="z-index: 1">{{ content.flight_arrival_departure }}</div>
    </div>
</template>

<script setup lang="ts">
import {useStore} from "vuex"
import { ref, computed } from "vue";
import DatePicker from "@/vue/planning/components/search/DatePickerV2.vue";

const store = useStore()
const showDatePicker = ref<boolean>(false)

const toggleShowHideDatePicker = (show: boolean): void => {
    showDatePicker.value = show
}

// Computed properties
const content = computed(() => store.state.content)

</script>

<style scoped>
.dropdown-container  {
    cursor: pointer;
}
.dropdown-input.dropdown {
	padding: 0px;
}
</style>